import { ModalMain } from "../styled";
import {
  FontGreyDarkFullRegular,
  FontGreyDarkMediumTitle,
} from "../../../../utils/typografyApp";
import SecondaryButton from "../../SecondaryButton";
import PrimaryButton from "../../PrimaryButton";
import { ExitForm } from "./styled";
import { useExitModalHook } from "./hook";

const ExitModal = ({ onClose }) => {
  const hook = useExitModalHook();

  return (
    <ModalMain>
      <ExitForm>
        <div className={"menu-content"}>
          <div className="content">
            <div className="title">
              <FontGreyDarkMediumTitle>Sair</FontGreyDarkMediumTitle>
            </div>
            <FontGreyDarkFullRegular>
              Tem certeza que deseja sair?
            </FontGreyDarkFullRegular>
          </div>

          <div className="actions-container">
            <SecondaryButton onClick={onClose}>Voltar</SecondaryButton>
            <PrimaryButton onClick={hook.logout}> Sair </PrimaryButton>
          </div>
        </div>
      </ExitForm>
    </ModalMain>
  );
};

export default ExitModal;
